import { CELL_NAME_MIN_PARTS, NAMED_RANGE_PREFIX } from './namedRangeUtils';

/**
 * Parses a Cosmic Frog cell name to extract context information
 * Expected format: olf_{modelId}_{tableName}_{itemId}_{propertyName}
 *
 * @param {string} cellName - The named range identifier
 * @returns {object} Context with modelName, tableName, itemId, propertyName
 * @throws {Error} If the cell name format is invalid
 */
export const getCellContextFromName = (cellName) => {
    // Split the input string on underscores
    const parts = cellName.split("_");

    // Validate format
    if (parts.length < CELL_NAME_MIN_PARTS) {
      throw new Error(`Invalid cell name format: expected at least ${CELL_NAME_MIN_PARTS} parts, got ${parts.length}`);
    }

    if (parts[0] !== NAMED_RANGE_PREFIX.slice(0, -1)) {
      throw new Error(`Invalid cell name format: expected prefix "${NAMED_RANGE_PREFIX}", got "${parts[0]}_"`);
    }

    // Extract the relevant parts, ignoring the prefix
    const modelName = formatAsGuid(parts[1]);
    const tableName = parts[2];
    const itemId = parseInt(parts[3], 10);
    const propertyName = parts.slice(4).join("_"); // Handles cases where the property name contains underscores

    // Return the structured data
    return {
      modelName,
      tableName,
      itemId,
      propertyName,
    };
    };

export const formatAsGuid = (input) => {
    if (input.length !== 32) {
      return input;
    }
  
    // Insert hyphens in the correct positions
    return `${input.slice(0, 8)}-${input.slice(8, 12)}-${input.slice(12, 16)}-${input.slice(16, 20)}-${input.slice(20)}`;
  };